module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main